import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

import type { PaymentMethod } from '@integrations/payment-methods';

import type { PaymentElementFormGroup } from '@common/types/payment-element.form';
import { SpPaymentMethodComponent } from '@components/sp-payment-method';

import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { SettingsFacade } from '@web/store/website/settings/settings.facade';
import { UserFacade } from '@web/store/user/user.facade';
import type { ShopCartWidgetDataFormType } from '@web/widgets/shop-cart/type/shop-cart-widget.type';

import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';

@Component({
    selector: 'web-shop-cart-form-payment-method-settings',
    templateUrl: './shop-cart-form-payment-method-settings.component.html',
    styleUrls: ['./shop-cart-form-payment-method-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WebSettingsModule, SpPaymentMethodComponent, TranslateModule],
})
export class ShopCartFormPaymentMethodSettingsComponent extends WebBaseControlTypedSettingsComponent<PaymentElementFormGroup> {
    public readonly paymentMethods = input.required<PaymentMethod[]>();
    public readonly paymentElements = input.required<ShopCartWidgetDataFormType['paymentElements']>();

    private readonly settingsFacade = inject(SettingsFacade);
    private readonly userFacade = inject(UserFacade);

    public readonly shopCurrency = toSignal(
        this.settingsFacade.shopSettings$.pipe(map((settings) => settings.currency))
    );

    public readonly isDisabledPaymentMethodSelect = toSignal(this.userFacade.isUserTariffFree$, {
        initialValue: false,
    });
}
